import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-设备流量*/
import React from 'react';
import { parse } from "../../../../../utils/commonUtilFunc";
import BossTable from "../../../../Common/BossTable";
import { connect } from "dva";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var DesIpFlowChart = /*#__PURE__*/function (_React$Component) {
  _inherits(DesIpFlowChart, _React$Component);
  function DesIpFlowChart(props) {
    var _this;
    _classCallCheck(this, DesIpFlowChart);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DesIpFlowChart).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_dpi_dstrank", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_dpi_dstrank",
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          ids: _this.props.ids,
          top: _this.state.top,
          dip: _this.state.name,
          sn: _this.sn,
          tunnel_dir: _this.tunnel_dir,
          companyid: _this.ifCompany ? _this.id : sessionStorage.getItem("companyId")
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        top: value
      }, function () {
        vm.get_dpi_dstrank();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchInputChange", function (e) {
      _this.setState({
        name: e.target.value
      });
    });
    _this.state = {
      name: "",
      top: "5"
    };
    var search = parse(_this.props.location.search);
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir = search.tunnel_dir_id;
    _this.sn = search.sn;
    _this.id = search.id;
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(DesIpFlowChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_dpi_dstrank();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var columns = [{
        title: "Target IP",
        dataIndex: 'dip',
        key: 'dip'
      }, {
        title: "domain name",
        dataIndex: 'domain',
        key: 'domain',
        render: function render(text) {
          return /*#__PURE__*/React.createElement("div", null, text || '-');
        }
      }, {
        title: "Target Port",
        dataIndex: 'dport',
        key: 'dport'
      }, {
        title: "Traffic (MB)",
        dataIndex: 'flow',
        key: 'flow',
        render: function render(text) {
          return text ? (text / 1024 / 1024).toFixed(4) : "";
        }
      }, {
        title: "Proportion of traffic (%)",
        dataIndex: 'percent',
        key: 'percent',
        render: function render(text, record) {
          return (100 * record.flow / 1024 / 1024 / _this2.props.flow).toFixed(2);
        }
      }];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 120,
          marginRight: 8,
          marginTop: 16
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter keywords",
        style: {
          width: 240,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleSearchInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_dpi_dstrank
      }, "search"), /*#__PURE__*/React.createElement(BossTable, {
        columns: columns,
        style: {
          marginTop: 16
        },
        dataSource: this.props.ci0303Info.dpiDstRankTableDataSource
      }));
    }
  }]);
  return DesIpFlowChart;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(DesIpFlowChart)));